import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ValueTable() {
  const items = [{
    name: 'Tomo 1 — El Mapa del Alma',
    value: '$7 USD'
  }, {
    name: 'Tomo 2 — Su Forma de Aprender',
    value: '$7 USD'
  }, {
    name: 'Tomo 3 — Sus Emociones',
    value: '$7 USD'
  }, {
    name: 'Tomo 4 — Su Forma de Comunicarse',
    value: '$7 USD'
  }, {
    name: 'Tomo 5 — Crianza Sin Conflicto',
    value: '$7 USD'
  }, {
    name: 'Tomo 6 — Conexión Profunda',
    value: '$7 USD'
  }, {
    name: 'Bonus 1 — Guía de Emergencia',
    value: '$5 USD'
  }, {
    name: 'Bonus 2 — Diccionario de Conductas',
    value: '$5 USD'
  }, {
    name: 'Bonus 3 — Rituales de Conexión',
    value: '$5 USD'
  }];
  return <section className="py-10 px-4 bg-white" data-id="element-216">
      <div className="max-w-3xl mx-auto" data-id="element-217">
        <FadeIn data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-burgundy-900 mb-12" data-id="element-219">
            Lo que estás recibiendo hoy
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-220">
          <div className="bg-white rounded-2xl shadow-2xl border-2 border-dusty-rose-200 overflow-hidden" data-id="element-221">
            <div className="overflow-x-auto" data-id="element-222">
              <table className="w-full text-left border-collapse" data-id="element-223">
                <thead data-id="element-224">
                  <tr className="bg-cream-50 border-b border-cream-200" data-id="element-225">
                    <th className="py-4 px-6 font-heading font-bold text-burgundy-900 text-lg" data-id="element-226">
                      Qué incluye
                    </th>
                    <th className="py-4 px-6 font-heading font-bold text-burgundy-900 text-lg text-right" data-id="element-227">
                      Valor real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-228">
                  {items.map((item, idx) => <tr key={idx} className="border-b border-cream-100 last:border-0 hover:bg-cream-50/50 transition-colors" data-id="element-229">
                      <td className="py-3 px-6 text-burgundy-800" data-id="element-230">
                        {item.name}
                      </td>
                      <td className="py-3 px-6 text-burgundy-600 text-right" data-id="element-231">
                        {item.value}
                      </td>
                    </tr>)}

                  {/* Total Row */}
                  <tr className="bg-cream-100/50 border-t-2 border-cream-200" data-id="element-232">
                    <td className="py-4 px-6 font-bold text-burgundy-800" data-id="element-233">
                      VALOR TOTAL DE LA COLECCIÓN
                    </td>
                    <td className="py-4 px-6 font-bold text-burgundy-600 text-right line-through decoration-dusty-rose-400 decoration-2" data-id="element-234">
                      $55 USD
                    </td>
                  </tr>

                  {/* Final Price Row */}
                  <tr className="bg-gradient-to-r from-gold-300 via-gold-200 to-gold-300" data-id="element-235">
                    <td className="py-7 px-6 font-heading font-bold text-burgundy-900 text-xl md:text-2xl" data-id="element-236">
                      TU INVERSIÓN HOY
                    </td>
                    <td className="py-7 px-6 font-heading font-bold text-burgundy-900 text-3xl md:text-4xl text-right" data-id="element-237">
                      $11 USD
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}